import {
  mapState,
  mapGetters
} from 'vuex'
import {
  getExhibitorEmployeeList,
  addInviteRecrd
} from '@/api/index'
import ChatWithExhibitor from '@/components/chat/ChatWithExhibitor'
import {
  inviteOrIM
} from '@/utils/function'
export const inviteMixin = {
  data() {
    return {
      employeeList: [],
      action: 'chat',
      identity: ''
    }
  },
  components: {
    ChatWithExhibitor
  },
  computed: {
    ...mapGetters(['info', 'subjectType']),
    ...mapState(['exhibitorDialogVisible'])
  },
  methods: {
    // 展品 展商的邀约
    inviteEventExh(data, index, type) {
      this.$store.commit('SET_INVITETYPE', 'invite')
      if (!this.isLoginFn()) return
      if (!this.todoPrission()) return
      let parms = {
        exhibitorId: data.exhibitorId
      }
      this.getExhEmployeeList(parms, data.exhibitorName, index, type, 'invite')
    },
    /**
     * parms  传的参数
     * corporateName 公司名称
     * index 当前数据在页面上的位置
     * type 展商、展品
     * action 消息/邀约
     */
    getExhEmployeeList(parms, corporateName, index, type, action) {
      this.employeeList = [];
      getExhibitorEmployeeList(parms)
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000) {
            let data = res.data
            if (data && !!data.list) {
              if (data.list.length != 0) {
                for (let i in data.list) {
                  this.employeeList.push({
                    'type': type,
                    'id': data.list[i]['id'],
                    'subscript': index,
                    'name': data.list[i]['name'] || '',
                    'avatar': data.list[i]['headImage'] || '',
                    'position': data.list[i]['post'] || '',
                    'corporateName': corporateName,
                    'easemobAccount': data.list[i]['easemobAccount'] || ''
                  })
                }
                if (action == 'invite') {
                  this.openInvitationDialog();
                } else if (action == 'message') {
                  this.openExhibitorChatDialog();
                }
              } else {
                this.$notify({
                  title: this.$t('footprints.tips'),
                  message: this.$t('footprints.exhibitorNoline'),
                  type: 'warning'
                });
              }
            } else {
              this.$notify({
                title: this.$t('footprints.tips'),
                message: this.$t('footprints.exhibitorNoline'),
                type: 'warning'
              });
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 展商、展品邀约
    openInvitationDialog() {
      this.to = 'exhibitor'
      this.action = 'invitation'
      this.$store.commit('setChatEmployeeList', this.employeeList)
      this.$store.commit('toogleExhibitorDialog')
    },
    // 确认邀约
    submitInvite(id, index, type) {
      console.log('邀约---确认---0000000009988-',type)
      let params = {
        projectId: this.info.projectId,
        userId: id
      }
      addInviteRecrd(params).then(res => {
        if (res.data && res.data.code === 1000) {
          inviteOrIM({
            acceptId:id,
            acceptSubjectType:'ACTOR',
            url:location.href,
            interateType: this.$store.getters.language == 'en' ? 'INTERATE_INVITE_EN' : 'INTERATE_INVITE_CN',
            language: this.$store.getters.language
          })
          this.$notify.success(this.$t('finds.inviteSuccess'));
          if (typeof index == 'function') {
            index(true)
          } else {
            this.updateInvite(true, index, type)
          }
          this.$store.commit('setReceiver', '')
          this.$store.commit('toogleExhibitorDialog')
          this.$store.commit('setChatEmployeeList', '')
        }
      })
    },
    // 展品 展商的消息
    msgEventExh(data, index, type) {
      this.$store.commit('SET_INVITETYPE', 'msg')
      if (!this.isLoginFn()) return
      if (!this.todoPrission()) return
      let parms = {
        exhibitorId: data.exhibitorId
      }
      console.log('---展品、展商：消息----', data, index, type, '=========')
      this.getExhEmployeeList(parms, data.atrName, index, type, 'message')
    },
    // 展商、展品、发消息
    openExhibitorChatDialog() {
      this.action = 'chat'
      this.$store.commit('setChatEmployeeList', this.employeeList)
      this.$store.commit('toogleExhibitorDialog')
    },
    openChatDialog(item) {
      console.log(item,'item')
      if (this.actorLimit('IM')) return
      inviteOrIM({
        acceptId: item.id,
        acceptSubjectType:"VISITOR",
        url: location.href,
        interateType: this.$store.getters.language == 'en' ? 'INTERATE_IM_EN' : 'INTERATE_IM_CN',
        language: this.$store.getters.language
      })
      this.$store.commit('setReceiver', item)
      this.$store.commit('toogleChatDialog')
    },

    msgEventPerson(data, index) {
      if (!this.isLoginFn()) return
      if (!this.todoPrission()) return
      if (data.easemobAccount != null && data.easemobAccount != undefined && data.easemobAccount != '') {
        let obj = {
          'type': 'person',
          'id': data.id,
          'subscript': index,
          'name': data.psjName || '',
          'avatar': data.headPortrait || '',
          'position': data.psjRank || '',
          'corporateName': data.psjComName,
          'easemobAccount': data.easemobAccount || ''
        }
        this.openChatDialog(obj, 'VISITOR')
      }
    },
  }
}